<template lang="pug">
  #app
    q-layout
      q-layout-header
        q-toolbar(color="primary")
          q-toolbar-title(style="display:flex;align-items:center;")
            img(width="100", src="../assets/images/logo.png")
            span(style="margin-left: 10px;") CUCA
          q-tabs
            q-route-tab(slot="title", icon="fa fa-home" to="/" replace label="Home")
            q-route-tab(slot="title", icon="fa fa-arrows-alt-h" to="/geometry" replace label="Geometry")
            q-route-tab(slot="title", icon="fa fa-cogs" to="/chipping" replace label="Chipping")
            q-route-tab(slot="title", icon="fa fa-sync-alt" to="/speeds_feeds" replace label="Speeds and Feeds")
            q-route-tab(slot="title", icon="fa fa-tachometer-alt" to="/performance" replace label="Performance")
      q-page-container
        router-view
</template>

<script>
import { openURL } from 'quasar'

export default {
  name: 'LayoutDefault',
  data () {
    return {
    }
  },
  methods: {
    openURL
  }
}
</script>

<style>
</style>
